import { Glue42Office } from "../../glue4office";
import { Config } from "./types";
import Excel from "./excel";

export default (config: Config): Glue42Office.Excel.API => {
    const excel = new Excel(config.agm);

    const methodsRegistered = excel.init();

    async function ready(): Promise<Glue42Office.Excel.API> {
        await methodsRegistered;
        return api;
    }

    const api: Glue42Office.Excel.API = {
        ready,
        openSheet: excel.openSheet,
        get sheets(): Glue42Office.Excel.Sheet[] {
            return excel.all;
        },
        onAddinStatusChanged: excel.onAddinStatusChanged,
        onNewWorksheet: excel.onNewWorksheet,
        get addinStatus() {
            return excel.addinStatus;
        },
        getWorkbooks: excel.getWorkbooks,
        getWorksheets: excel.getWorksheets,
    };

    return api;
};
